import { axiosRequest } from '../middlewares/axios'
import {conf} from '../config/config'

export const enedisConsentService = {
	search,
	getById,
	update,
	create,
	start,
	startLink,
	result,
	remove
}

function search(searchParams:any) {
  return axiosRequest.postRequest(conf.API_URL + '/enedis-consent/search', searchParams)
}

function getById(id) {
  return axiosRequest.getRequest(conf.API_URL + '/enedis-consent/get-full', {params:{id:id}})
}

function update(consent:any){
	return axiosRequest.putRequest(conf.API_URL + '/enedis-consent/'+consent.id, consent)
}

function create(consent:any){
	return axiosRequest.postRequest(conf.API_URL + '/enedis-consent/create', consent)
}


function start(code:string){
	return axiosRequest.getRequest(conf.API_URL + '/enedis-consent/get-for-start-page/'+code)
}

function startLink(code:string){
	return axiosRequest.getRequest(conf.API_URL + '/enedis-consent/get-start-link/'+code)
}

function result(code:string){
	return axiosRequest.getRequest(conf.API_URL + '/enedis-consent/get-for-result-page/'+code)
}

// suppression de la demande (auteur ou admin) — le consentement donné chez Enedis n'est pas révoqué
function remove(id:number){
	return axiosRequest.deleteRequest(conf.API_URL + '/enedis-consent/' + id, {})
}
